import type { ReactNode } from 'react';

type BadgeTone = 'green' | 'red' | 'amber' | 'blue' | 'orange' | 'slate' | 'brand';

interface BadgeProps {
  tone?: BadgeTone;
  children: ReactNode;
  className?: string;
}

const TONE_CLASSES: Record<BadgeTone, string> = {
  green: 'bg-green-100 text-green-800',
  red: 'bg-red-100 text-red-800',
  amber: 'bg-amber-100 text-amber-800',
  blue: 'bg-blue-100 text-blue-800',
  orange: 'bg-orange-100 text-orange-800',
  slate: 'bg-slate-200 text-slate-700',
  brand: 'bg-brand-50 text-brand-700',
};

export function Badge({ tone = 'slate', children, className = '' }: BadgeProps) {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${TONE_CLASSES[tone]} ${className}`}>
      {children}
    </span>
  );
}
